import { EGetFavoritesListActionTypes } from '../../actions/favorites';
import { EToggleFavoritesEntityType } from '../../actions/favorites/toggleEntityType';
import { EHeaderStateActionType } from '../../actions/headerState';
import { EFavoritesStatus, IFavoritesState } from '../../types/favorites';
import { TReduxActions } from '../../types/redux';

const defaultState: IFavoritesState = {
  count: 0,
  favorites: [],
  entityTypes: 'ads',
  status: EFavoritesStatus.Initial,
};

export function favoritesReducer(state: IFavoritesState = defaultState, action: TReduxActions): IFavoritesState {
  switch (action.type) {
    case EGetFavoritesListActionTypes.Loading:
      return {
        ...state,
        status: EFavoritesStatus.Loading,
      };

    case EGetFavoritesListActionTypes.Succeed:
      return {
        ...state,
        favorites: [...state.favorites, ...action.payload],
        status: EFavoritesStatus.Succeed,
      };

    case EGetFavoritesListActionTypes.Failed:
      return {
        ...state,
        status: EFavoritesStatus.Failed,
      };

    case EToggleFavoritesEntityType.Toggle:
      return {
        ...state,
        entityTypes: action.payload,
        status: EFavoritesStatus.Initial,
        favorites: [],
      };
    case EHeaderStateActionType.Update:
      return {
        ...action.payload.favorites,
        favorites: [],
        entityTypes: 'ads',
        status: EFavoritesStatus.Initial,
      };
  }

  return state;
}
